import React, { useEffect, useState } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map } from "lodash";
import { useAuth } from "../../../../hooks";
import { getServers } from "../../../../api";
import { ServerItem } from "../ServerItem";
import "./ListServers.scss";

export function ListServers({ reload, onReload }) {
  const { accessToken } = useAuth();
  const [servers, setServers] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 1, page: 1 });

  useEffect(() => {
    (async () => {
      try {
        const response = await getServers({ page, limit: 5 }, accessToken);
        // Esperamos { servers: { docs, page, totalPages, totalDocs, limit } }
        setServers(response.servers.docs);
        setPagination({
          limit: response.servers.limit,
          page: response.servers.page,
          total: response.servers.totalPages,
          totalDocs: response.servers.totalDocs,
        });
      } catch (e) {
        console.error(e);
      }
    })();
  }, [page, reload, accessToken]);

  const changePage = (_e, data) => setPage(data.activePage);

  if (!servers) return <Loader active inline="centered" />;
  if (size(servers) === 0) return <h2>No hay servidores</h2>;

  return (
    <div className="list-servers">
      {map(servers, (server) => (
        <ServerItem key={server._id} server={server} onReload={onReload} />
      ))}

      <div className="list-servers__pagination">
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
